import cn from "classnames";
import {
    assistantChatReportTypes,
    assistantChatReportTypesEnum,
    notificationFlags,
    notificationFlagsEnum,
} from "helpers/enums";
import { enumLabel } from "helpers/system";
import React, { useEffect, useState } from "react";
import { applySettings, getSettings, setMessagesAsRead } from "sources/assistantChat";

export default function Settings(props) {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([
        {
            reportType: assistantChatReportTypesEnum.EveryWeekStatistic,
            flags: 0,
            pushTime: "08:00:00",
            mailTime: "08:00:00",
        },
        {
            reportType: assistantChatReportTypesEnum.InvolvementAnalysis,
            flags: 0,
            pushTime: "08:00:00",
            mailTime: "08:00:00",
        },
    ]);

    useEffect(() => {
        setMessagesAsRead();
        getSettings().then((data) => {
            setData(data);
            setLoading(false);
        });
    }, []);

    const saveData = (e) => {
        e.preventDefault();
        setLoading(true);
        data.forEach((item) => {
            if (item.pushTime.split(":").length === 2) {
                item.pushTime = `${item.pushTime}:00`;
            }
            if (item.mailTime.split(":").length === 2) {
                item.mailTime = `${item.mailTime}:00`;
            }
        });
        applySettings(data).then((res) => {
            setLoading(false);
            if (res) {
                props.back();
            }
        });
    };

    const renderFlag = (flagName, settings) => {
        const flagItem = notificationFlags.find((item) => item.value === flagName);
        const checked = (settings.flags & flagItem.intValue) === flagItem.intValue;
        const timeKey = flagName === notificationFlagsEnum.PushNotifications ? "pushTime" : "mailTime";

        const setSetting = (newValue) =>
            setData(data.map((item) => (item.reportType === settings.reportType ? newValue : item)));

        const toggleFlag = (flagValue, newValue) =>
            setSetting({ ...settings, flags: newValue ? settings.flags + flagValue : settings.flags - flagValue });

        return (
            <tr>
                <td>{enumLabel(notificationFlags, flagName)}</td>
                <td>
                    <div className="align-items-center" onClick={() => toggleFlag(flagItem.intValue, !checked)}>
                        <span
                            className={cn("checkbox checkbox--inline mr-2", { "checkbox--checked": checked })}
                            name="shareAccessEnabled"
                        />
                    </div>
                </td>
                <td>
                    <input
                        disabled={!checked}
                        type="time"
                        placeholder="08:00"
                        className="form-control form-control-xs"
                        value={settings[timeKey]}
                        onChange={(e) => setSetting({ ...settings, [timeKey]: e.target.value })}
                    />
                </td>
            </tr>
        );
    };

    return (
        <form className={cn({ loading })} onSubmit={saveData}>
            <h5 className="pb-3">Настройки уведомлений</h5>
            {data.map((item) => (
                <div key={item.reportType} className="pb-3">
                    <strong className="pb-2">{enumLabel(assistantChatReportTypes, item.reportType)}</strong>
                    <table className="table table-sm table--vertical-centered">
                        <thead>
                            <tr>
                                <th />
                                <th>Включено</th>
                                <th>Время уведомления</th>
                            </tr>
                        </thead>
                        <tbody>
                            {renderFlag(notificationFlagsEnum.PushNotifications, item)}
                            {renderFlag(notificationFlagsEnum.MailNotifications, item)}
                        </tbody>
                    </table>
                </div>
            ))}
            <button className="btn btn-sm btn-brand float-right" type="submit">
                Сохранить
            </button>
        </form>
    );
}
